export default __webpack_public_path__ + "static/media/kebabgrey.221c1284.svg";